import React from "react";
import DropdownContext from "react-bootstrap/esm/DropdownContext";

type SakhadComplaintCodeDropdownMenuProp = {
  index: number;
  updateData: (index: number) => void;
  disabled: boolean;
};

const items = [
  "- - -",
  "سرفه مزمن",
  "تب طول کشیده",
  "مرگ ناگهانی",
  "شوک عفونی",
  "بیماری‌های آمیزشی",
  "تب و تورم غدد لنفاوی",
  "شبه آنفولانزا",
  "اسهال خونی",
  "اسهال حاد غیرخونی",
  "زردی حاد",
  "فلج شل حاد",
  "تب و علائم نورولوژیک",
  "مسمومیت غذایی",
  "تب و خون‌ریزی",
  "تب و راش حاد",
  "اختلال شدید تنفسی",
  "سایر",
];

export const SakhadComplaintCodeDropdownMenu = ({
  index,
  updateData,
  disabled,
}: SakhadComplaintCodeDropdownMenuProp) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    updateData(Number(event.target.value));
  };

  return (
    <>
      <select
        value={index}
        disabled={disabled}
        onChange={handleChange}
        className={`rounded rounded-3 p-2 px-3 border-1 border-gray ${
          disabled ? "bg-gray-disabled" : "bg-white"
        }`}
      >
        {items.map((item, i) => (
          <option key={i} value={i}>
            {item}
          </option>
        ))}
      </select>
    </>
  );
};
